const ITEMS = [
  "Portraits", "Couples", "Familles", "Studio Quatre Saisons", "Événements",
  "Paysages", "Nature & Animaux", "Projets Spéciaux",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#D4AF37]/15 bg-[#0D0D10] py-5 select-none">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-lg sm:text-xl text-slate-400 px-8">{item}</span>
            <span className="text-[#D4AF37] text-xs">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
